var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignupPrihvatanjeUslova(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 165 165",
    style: {
      enableBackground: "new 0 0 165 165"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6E5DD8;}\n\t.st1{fill:#FA7268;}\n\t.st2{fill:#AA6276;}\n\t.st3{fill:#159497;}\n\t.st4{fill:none;stroke:#6E5DD8;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#159497;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st6{fill:#231F20;}\n\t.st7{fill:none;stroke:#FA7268;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st8{fill:#FFFFFF;stroke:#231F20;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st9{fill:#FFFFFF;stroke:#FA7268;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st10{fill:#6E5DD8;stroke:#FA7268;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#231F20;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{fill:none;stroke:#AA6276;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st13{fill:#FFFFFF;}\n\t.st14{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st15{fill:none;stroke:#000000;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st16{fill:#FFFFFF;stroke:#6E5DD8;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st17{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st18{fill:#FFFFFF;stroke:#159497;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st19{fill:#FFFFFF;stroke:#AA6276;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st20{fill:#FA7268;stroke:#231F20;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st21{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st22{fill:#FA7267;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.6,132.3c-4.5,0-8.2-3.7-8.2-8.2h0V32.7h70.4v91.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.6,132.3c4.5,0,8.2-3.7,8.2-8.2h70.4c0,4.5-3.7,8.2-8.2,8.2H41.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.3,
    y: 43.1,
    className: "st13",
    width: 52.7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.3,
    y: 48.7,
    className: "st13",
    width: 52.7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.3,
    y: 54.3,
    className: "st13",
    width: 52.7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.3,
    y: 59.9,
    className: "st13",
    width: 52.7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.3,
    y: 65.6,
    className: "st13",
    width: 52.7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.3,
    y: 71.2,
    className: "st13",
    width: 52.7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.3,
    y: 76.8,
    className: "st13",
    width: 52.7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.3,
    y: 82.4,
    className: "st13",
    width: 52.7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.3,
    y: 88.1,
    className: "st13",
    width: 52.7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.3,
    y: 93.7,
    className: "st13",
    width: 52.7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.3,
    y: 99.3,
    className: "st13",
    width: 52.7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.3,
    y: 104.9,
    className: "st13",
    width: 52.7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.3,
    y: 110.5,
    className: "st13",
    width: 52.7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.3,
    y: 116.2,
    className: "st13",
    width: 52.7,
    height: 1
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 109.8,
    cy: 79.2,
    r: 31.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M100.4,96.7c-0.1,0-0.2,0-0.3,0c-0.7-0.1-1.3-0.5-1.7-1.1L88,80.6c-0.8-1.1-0.5-2.7,0.6-3.5 c1.1-0.8,2.7-0.5,3.5,0.6l8.8,12.7l27.6-22.9c1.1-0.9,2.6-0.7,3.5,0.3c0.9,1.1,0.7,2.6-0.3,3.5L102,96.1 C101.6,96.5,101,96.7,100.4,96.7z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupPrihvatanjeUslova);
export default __webpack_public_path__ + "static/media/Signup-prihvatanje_uslova.14160aa665b8328baf623cd76e7b8a87.svg";
export { ForwardRef as ReactComponent };